// SPDX-License-Identifier: AGPL-3.0-or-later

import {Routes} from '@app/app/Routes';
import FeedCategories, {type FeedCategory} from '@app/features/feed/state/FeedCategories';
import FeedTabs from '@app/features/feed/state/FeedTabs';
import {isFeedCategoriesEnabled} from '@app/features/feed/utils/FeedUtils';
import * as RouterUtils from '@app/features/navigation/utils/RouterUtils';

const NO_CATEGORIES: ReadonlyArray<FeedCategory> = [];

// Read on every render, so the limit turned off hides every category surface at once.
export function shownFeedCategories(): ReadonlyArray<FeedCategory> {
	return isFeedCategoriesEnabled() ? FeedCategories.categories : NO_CATEGORIES;
}

// The open category while the list still offers it; a category closed meanwhile falls back to the tabs.
export function selectedFeedCategory(): FeedCategory | null {
	const categoryId = FeedTabs.selectedCategoryId;
	return categoryId !== null && isFeedCategoriesEnabled() ? FeedCategories.get(categoryId) : null;
}

// TEMPORARY: two designs side by side until one is picked; then the other and this key go. A raw localStorage key, so
// the preview switches it from the browser console; unreadable storage keeps the default.
// 'rail': the topics card on top of the profile rail. 'nav': the topics as rows in the feed sidebar.
export type FeedCategoryLayout = 'rail' | 'nav';
export const FEED_CATEGORY_LAYOUT_KEY = 'micup.feedCategoryLayout';

export function feedCategoryLayout(): FeedCategoryLayout {
	try {
		return window.localStorage.getItem(FEED_CATEGORY_LAYOUT_KEY) === 'nav' ? 'nav' : 'rail';
	} catch {
		return 'rail';
	}
}

// The post box's text field, which "Share in this topic" focuses.
export const FEED_COMPOSER_TEXT_ID = 'feed-composer-text';

// A category opens in the feed page's main column: from a post page, a section page or a modal the feed comes back.
export function openFeedCategory(categoryId: string): void {
	FeedTabs.openCategory(categoryId);
	if (RouterUtils.getCurrentPath() !== Routes.FEED) RouterUtils.transitionTo(Routes.FEED);
}

// The topic lists open a category, and a press on the open one goes back to the tabs.
export function toggleFeedCategory(categoryId: string): void {
	if (FeedTabs.selectedCategoryId === categoryId && RouterUtils.getCurrentPath() === Routes.FEED) {
		FeedTabs.closeCategory();
		return;
	}
	openFeedCategory(categoryId);
}
